import React from 'react';
import './App.css';
import SearchBar from '../SearchBar/SearchBar';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import Results from '../Results/Results';
import Playlist from '../Playlist/Playlist';
import Spotify from '../../util/Spotify';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchResults: [],
      recentlyPlayed: [],
      playlistName: 'My Playlist',
      playlistTracks: [],
      audioSrc: ''
    };
    this.addTrack = this.addTrack.bind(this);
    this.removeTrack = this.removeTrack.bind(this);
    this.updatePlaylistName = this.updatePlaylistName.bind(this);
    this.savePlaylist = this.savePlaylist.bind(this);
    this.search = this.search.bind(this);
    this.getRecentlyPlayed = this.getRecentlyPlayed.bind(this);
    this.updateAudioSrc = this.updateAudioSrc.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }

  addTrack(track) {
    let savedTracks = this.state.playlistTracks;
    if(savedTracks.find(savedTrack => savedTrack.id === track.id)) {
      return;
    };
    savedTracks.push(track);

    // Remove track from it's original list
    if(track.location === 'search-results') {
      this.setState({
        // Remove added track from search results
        searchResults: this.state.searchResults.filter(savedTrack => savedTrack.id !== track.id),
        playlistTracks: savedTracks
      });
    } else {
      this.setState({
        // Remove added track from search results
        recentlyPlayed: this.state.recentlyPlayed.filter(savedTrack => savedTrack.id !== track.id),
        playlistTracks: savedTracks
      });
    }
  }

  removeTrack(track) {
    let savedTracks = this.state.playlistTracks;
    savedTracks = savedTracks.filter(savedTrack => savedTrack.id !== track.id);

    if(track.location === 'search-results') {
      // Add removed track back into searchResults
      let searchResults = this.state.searchResults;
      searchResults.push(track);

      this.setState({
        searchResults: searchResults,
        playlistTracks: savedTracks
      });
    } else {
      // Add removed track back into searchResults
      let recentlyPlayed = this.state.recentlyPlayed
      recentlyPlayed.push(track);  

      this.setState({
        recentlyPlayed: recentlyPlayed,
        playlistTracks: savedTracks
      });
    }

  }

  updatePlaylistName(name) {
    this.setState({
      playlistName: name
    })
  }

  savePlaylist() {
    let trackUris = this.state.playlistTracks.map(track => track.uri);
    Spotify.savePlaylist(this.state.playlistName, trackUris).then(() => {
      this.setState({
        playlistName: 'New Playlist',
        playlistTracks: []
      })
    })
  }

  search(term) {
    Spotify.search(term).then( searchResults => {
    this.setState({ searchResults: searchResults })
    }).then(this.getRecentlyPlayed());
  }

  getRecentlyPlayed() {
    Spotify.getRecentlyPlayed().then( searchResults => {
      this.setState({ recentlyPlayed: searchResults })
      });
  }
  
  updateAudioSrc(track) {
    this.setState({
      audioSrc: track.sample
    })
  }

  handleLoad() {
    Spotify.getAccessToken();
  }

  componentDidMount() {
    window.addEventListener('load', this.handleLoad());
    return () => {
      window.removeEventListener('load', this.handleLoad());
    };
  }

  render() {
    return (
      <div>
        <h1>Mus<span className="highlight">i</span>c <span className="highlight">Muse</span></h1>
        <div className="App" >
          <SearchBar onSearch={this.search} />
          <AudioPlayer audioSrc={this.state.audioSrc}/>
          <div className="App-playlist">
            <Results searchResults={this.state.searchResults}
                            onChange={this.getRecentlyPlayed} 
                            onAdd={this.addTrack}
                            updateAudioSrc={this.updateAudioSrc}
                            recentlyPlayed={this.state.recentlyPlayed}/>
            <Playlist playlistName={this.state.playlistName}
                      playlistTracks={this.state.playlistTracks} 
                      onRemove={this.removeTrack}
                      updateAudioSrc={this.updateAudioSrc}
                      onNameChange={this.updatePlaylistName}
                      onSave={this.savePlaylist} />
          </div>
        </div>
      </div>
    );
  }
}

export default App;
